let apiBaseUrl = "https://" + window.location.hostname;

export const getBadgeImage = cat => {
  const categoria = parseInt(cat);
  let srcImg;
  if (categoria >= 200 && categoria < 300)
    srcImg = "/cdn/images/level-badges/silver.svg";
  else if (categoria >= 300) srcImg = "/cdn/images/level-badges/gold.svg";
  else srcImg = "/cdn/images/level-badges/bronze.svg";
  return srcImg;
};

export const bancosNAI = [
  // { "nome": "Banese", "logo": "/images/banese.png", "url": "https://www.banese.com.br" },
  // { "nome": "Banestes", "logo": "/images/banestes.png", "url": "https://www.banestes.com.br" },
  // { "nome": "Itaú", "logo": "/images/itau.png", "url": "https://www.itau.com.br" },
  // { "nome": "Sicredi", "logo": "/images/sicredi.png", "url": "https://www.sicredi.com.br" },
  // { "nome": "Banpará", "logo": "/images/banpara.png", "url": "https://www.banpara.com.br" },
  // { "nome": "Crefisa", "logo": "/images/crefisa.png", "url": "https://www.crefisa.com.br" },
  // { "nome": "Banco Inter", "logo": "/images/inter.png", "url": "https://www.bancointer.com.br" },
  // { "nome": "Banco Seguro", "logo": "/images/seguro.png", "url": "https://www.bancoseguro.com.br" },
  // { "nome": "Original", "logo": "/images/original.png", "url": "https://www.original.com.br" },
  // { "nome": "BMG", "logo": "/images/bmg.png", "url": "https://www.bancobmg.com.br" },
  // { "nome": "C6 S.A", "logo": "/images/c6.png", "url": "https://www.c6bank.com.br" },
  // { "nome": "BMB", "logo": "/images/bmb.png", "url": "https://www.mercantildobrasil.com.br" },
  // { "nome": "Safra", "logo": "/images/safra.png", "url": "https://www.safra.com.br" },
  // { "nome": "Banco Pan", "logo": "/images/pan.png", "url": "https://www.bancopan.com.br" },
  // { "nome": "Daycoval", "logo": "/images/daycoval.png", "url": "https://www.daycoval.com.br" }
];

export const levelTranslate = levelId => {
  switch (levelId) {
    case 1:
      return `${process.env.REACT_APP_URL_ASSETS}/images/level-badges/bronze.svg`;
    case 2:
      return `${process.env.REACT_APP_URL_ASSETS}/images/level-badges/silver.svg`;
    case 3:
      return `${process.env.REACT_APP_URL_ASSETS}/images/level-badges/gold.svg`;
    default:
      return levelTranslate(1);
  }
};

export const categorySectionTranslate = section => {
  switch (section) {
    case "RECEITA_FEDERAL":
      return "Receita Federal";
    case "INSS":
      return "INSS";
    case "BALCAO_GOVBR":
      return "Balcão gov.br";
    case "SIGEPE":
      return "SIGEPE";
    case "SENATRAN":
      return "SENATRAN (CNH)";
    case "BANCO":
      return "Bancos";
    case "TSE":
      return "Justiça Eleitoral (TSE)";
    case "CIN":
      return "Carteira de Identidade (CIN)";
    case "CERTIFICADO_DIGITAL":
      return "Certificado Digital";

    default:
      return "";
  }
};
